module.exports = __webpack_public_path__ + "img/spartan-roof-replacement-waterproofing-06-xlarge.105b973c.jpg";